import { useState } from 'react';

import Section from 'molecules/Section';

import StepPanel from 'components/Calculators/StepPanel';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { SectionProps } from 'molecules/Section';
import type { FC } from 'react';

export interface CalculatorsProps extends ContentfulComponentSingleInstance, SectionProps {}

const Calculators: FC<CalculatorsProps> = props => {
  const [step, setStep] = useState(1);

  return (
    <Section sectionAs="div" background="gray100" {...props}>
      <div className="flex w-full flex-col gap-8 sm:gap-12 lg:gap-16">
        <StepPanel returnStep={value => setStep(value)} parentStep={step} />
      </div>
    </Section>
  );
};

export default Calculators;
